// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSafetyAnchorPointsRequestModel from '../../model/get-safety-anchor-points-request-model';
import GetSafetyAnchorPointsRequestDTO from '../dto/get-safety-anchor-points-request-dto';
import dtoSchema from '../schemas/get-safety-anchor-points-request-schema';

export default abstract class GetSafetyAnchorPointsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSafetyAnchorPointsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.sihaDocumentationId = data.sihaDocumentationId;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  sihaDocumentationId?: number;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetSafetyAnchorPointsRequestDTO>): GetSafetyAnchorPointsRequestModel;
  static toModel(dto: DeepPartial<GetSafetyAnchorPointsRequestDTO> | undefined | null): GetSafetyAnchorPointsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSafetyAnchorPointsRequestDTO> | undefined | null): GetSafetyAnchorPointsRequestModel | undefined {
    return dto ? new GetSafetyAnchorPointsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSafetyAnchorPointsRequestModel> | GetSafetyAnchorPointsRequestModel): GetSafetyAnchorPointsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      sihaDocumentationId: unwrapped.sihaDocumentationId,
      searchCriteria: unwrapped.searchCriteria,
    } as GetSafetyAnchorPointsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSafetyAnchorPointsRequestModel, can not map to GetSafetyAnchorPointsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
